angular.module('rjmNg.common.api').factory 'IntegrationTypes', [
  "$resource"
  "serviceUrl"
  (
    $resource
    serviceUrl
  ) ->

    (clientId) ->

      EXTRA_INTEGRATION_TYPE_CONFIGS = [
        type: 'userpush'
        access: true
        display_name: 'Upload a File'
        replication_type: "iapi"
        pricing_tier: "standard"
        cbi_is_available: true
      ,
        type: 'googleAdwords'
        access: true
        display_name: 'Google AdWords'
        replication_type: "web"
        pricing_tier: "standard"
        cbi_is_available: true
      ,
        type: 'googleEcommerce'
        access: true
        display_name: 'Google Ecommerce'
        replication_type: "web"
        pricing_tier: "standard"
        cbi_is_available: true
      ,
        type: 'googleAnalytics'
        access: true
        display_name: 'Google Analytics Live'
        replication_type: "live"
        pricing_tier: "standard"
        cbi_is_available: true
      ,
        type: 'hosted'
        access: false
        directions: ['outbound']
        display_name: 'Hosted Warehouse'
        pricing_tier: 'premium'
        protocol: 'redshift'
        replication_type: 'db'
      ]

      filterAndAppendIntegrationTypes = (integrationTypes) ->
        # filter out integrations with type of `googleanalytics`
        # we have to build their config on the front end until
        # the backend can return them as different types.
        allExceptGoogle = integrationTypes.filter (integration) ->
          integration.type != "googleanalytics"

        allExceptGoogle.concat(EXTRA_INTEGRATION_TYPE_CONFIGS)

      defaultParams =
        method: 'GET'
        cache: true
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        get: angular.extend {}, defaultParams,
          url: serviceUrl("/integration-types/:type")
          type: '@type'
        getAll: angular.extend {}, defaultParams,
          url: serviceUrl("/integration-types")
          isArray: true
        getAllForClient: angular.extend {}, defaultParams,
          url: serviceUrl("/clients/#{clientId}/integration-types")
          isArray: true

      integrationTypes = $resource(serviceUrl("/integration-types/"), {}, actions)

      get: (type) ->
        integrationTypes.get({type: type}).$promise

      getAll: ->
        integrationTypes.getAll({}).$promise

      getAllForClient: ()->
        integrationTypes.getAllForClient().$promise
        .then (integrationTypes) ->
          filterAndAppendIntegrationTypes(integrationTypes)
]
